export interface strings {
  title: string;
  subtitle: string;
}

export enum ChartTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum TitleAlign {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum ChartType {
  LINE = 'line',
  AREA = 'area',
  BAR = 'bar',
  RADAR = 'radar',
  DONUT = 'donut',
  CUSTOM = 'custom',
}

export interface AreaSeries {
  name?: string;
  data: number[];
}

export interface CustomGraphColor {
  lineColor: string[];
  fillColor: string[];
}
